import { render } from "./UsersScore.vue?vue&type=template&id=3a94b0f8"
import script from "./UsersScore.vue?vue&type=script&lang=js"
export * from "./UsersScore.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sr.vlas/vendor/v-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__